export class CustVideoRequestParm {
	public parmName : string;
    public parmValue: Object;

	constructor(o?:any) {
		Object.assign(this, o);
	}
}
